import { transport } from 'config/transport';

export function callApiSaveInvoicePayments(congDoanId, classId, invoiceId, body) {
    return transport.put(`/mamnon/${congDoanId}/thuchi/${classId}/thumamnon/payment/${invoiceId}`, body);
}
